<template>
    <el-dialog :title="video.name" :visible.sync="visible" :before-close="onClose" append-to-body modal-append-to-body close-on-click-modal width="30%">
        <video controls="controls" class="video-preview" :src="video.url" ref="video"></video>
    </el-dialog>
</template>

<script>
export default {
    name: 'VideoPreview',
    props: {
        video: {
            type: [Object],
            default: function() {
                return {
                    name: null,
                    url: null
                };
            }
        }
    },
    data() {
        return {
            visible: false
        };
    },
    mounted() {},
    methods: {
        show() {
            this.visible = true;
        },
        onClose() {
            this.visible = false;
            this.$refs.video && this.$refs.video.pause();
        }
    }
};
</script>

<style lang="scss" scoped>
.video-preview {
    max-width: 100%;
    display: block;
    margin: 0 auto;
}
</style>
